import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-new-session-dialog',
  templateUrl: './new-session-dialog.component.html',
  styleUrls: ['./new-session-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewSessionDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
